export const PAGE_SIZE = 12;
export const transformAggregationsToStructuredData = (buckets: any, country: any) => {
  if (buckets.length === 0) return {};

  const result = {
    brandsList: [],
    colorsList: [],
    gendersList: [],
    releaseYearsList: [],
    productCategoriesList: [],
    minimumPriceCents: null,
    maximumPriceCents: null,
    productConditionsList: [],
    sizesList: [],
    silhouettesList: [],
    designersList: [],
    seasonsList: [],
    underRetail: false,
    instantShip: false,
    hasNewInApparel: false,
    yearsList: [],
  };

  const transformValuesList = (valuesList) =>
    valuesList.map((v) => ({ name: v.value, count: v.count, slug: v.slug }));

  const transformSizesBucketNested = (valuesList) => {
    return valuesList.map((categoryEntry) => {
      const categoryName = categoryEntry.value;
      let categoryCount = 0;

      const gendersList = [];

      for (const genderBucket of categoryEntry.bucketsList || []) {
        if (genderBucket.bucketName !== 'genders') continue;

        for (const genderEntry of genderBucket.valuesList || []) {
          let genderName = genderEntry.slug || genderEntry.value;

          if (categoryEntry.value !== 'shoes') {
            genderName = `UNIVERSAL_${genderName}`;
          } else {
            genderName = `${country || 'US'}_${genderName}`;
          }
          let genderCount = 0;
          const availableSizesMap = new Map();

          const sizesBucket = genderEntry.bucketsList?.find((b) => b.bucketName === 'sizes');

          for (const sizeEntry of sizesBucket?.valuesList || []) {
            const size = sizeEntry.sizeValue?.size;
            const { count } = sizeEntry;

            if (size) {
              genderCount += count;
              categoryCount += count;

              if (!availableSizesMap.has(size)) {
                availableSizesMap.set(size, {
                  name: size,
                  count,
                });
              } else {
                availableSizesMap.get(size).count += count;
              }
            }
          }

          gendersList.push({
            name: genderName,
            count: genderCount,
            availableSizesList: [...availableSizesMap.values()].sort((a, b) => b.count - a.count),
          });
        }
      }

      return {
        name: categoryName,
        count: categoryCount,
        gendersList,
      };
    });
  };

  for (const bucket of buckets) {
    switch (bucket.bucketName) {
      case 'brands':
        result.brandsList = transformValuesList(bucket.valuesList);
        break;
      case 'colors':
        result.colorsList = transformValuesList(bucket.valuesList);
        break;
      case 'genders':
        result.gendersList = transformValuesList(bucket.valuesList);
        break;
      case 'release_years':
        result.releaseYearsList = transformValuesList(bucket.valuesList);
        break;
      case 'years':
        result.yearsList = transformValuesList(bucket.valuesList);
        break;
      case 'conditions':
        result.productConditionsList = transformValuesList(bucket.valuesList);
        break;
      case 'sizes':
        result.sizesList = transformSizesBucketNested(bucket.valuesList);
        break;
      case 'price_min':
        if (
          bucket.valuesList?.[0]?.moneyValue &&
          typeof bucket.valuesList[0].moneyValue.amountCents === 'number'
        ) {
          result.minimumPriceCents = bucket.valuesList[0].moneyValue;
        }
        break;
      case 'price_max':
        if (
          bucket.valuesList?.[0]?.moneyValue &&
          typeof bucket.valuesList[0].moneyValue.amountCents === 'number'
        ) {
          result.maximumPriceCents = bucket.valuesList[0].moneyValue;
        }
        break;
      case 'categories':
        result.productCategoriesList = bucket.valuesList.map((category) => {
          const productTypes =
            category.bucketsList?.find((b) => b.bucketName === 'product_type')?.valuesList || [];

          const productTypesList = productTypes.map((pt) => {
            let activities =
              pt.bucketsList?.find((b) => b.bucketName === 'activities')?.valuesList || [];

            // If the product type is sneakers, we need to include the activities from the "archive_activities" bucket as well

            if (pt?.value?.toLowerCase() === 'sneakers') {
              const archiveActivities =
                pt.bucketsList?.find((b) => b.bucketName === 'archive_activities')?.valuesList ||
                [];
              activities = archiveActivities.filter((a) =>
                ['basketball', 'lifestyle', 'running', 'skateboarding'].includes(
                  a?.value?.toLowerCase(),
                ),
              );
              // add activity: to the value
              // this will make the difference between activities filters and level 3 taxonomy filters on the backend
              activities = activities.map((a) => ({
                ...a,
                value: `activity:${a.value}`,
              }));
            }
            return {
              name: pt.value,
              count: pt.count,
              activitiesList: transformValuesList(activities),
            };
          });

          return {
            name: category.value,
            count: category.count,
            productTypesList,
          };
        });

        result.hasNewInApparel = result.productCategoriesList.some(
          (category) => category.name === 'Apparel',
        );
        break;

      case 'instant_ship':
        result.instantShip = Number.parseInt(bucket.valuesList?.[0]?.value || '0', 10) > 0;
        break;
      case 'under_retail':
        result.underRetail = Number.parseInt(bucket.valuesList?.[0]?.value || '0', 10) > 0;
        break;
      default:
        break;
    }
  }

  return result;
};
